module.exports = __webpack_public_path__ + "static/img/bg.801254b.png";